import { CustomAnalyticsEvent } from '@superfunnel/types/account';

// Changes whenever what a custom event counts changes, so cached analytics
// refetch after its filters or value are edited.
export const customEventDefinitionsKey = (events?: CustomAnalyticsEvent[]) =>
  JSON.stringify(
    events?.map(({ id, eventName, filterRules, value }) => [
      id,
      eventName,
      filterRules ?? [],
      value ?? null,
    ]) ?? [],
  );
